'use strict';

const recaptchaSiteKey = '6LdiCz0lAAAAAKQ8raGMeEmR9oyI_Db7Mzx7q-T-';

export const recaptchaUpdater = type => {
  //executa imadiatamente no carregamento da página
  recaptchaInit(type);

  //executa a cada 5 minutos a troca do token
  setInterval(() => recaptchaInit(type), 60000);
};

const recaptchaInit = type => {
  grecaptcha.ready(function () {
    grecaptcha.execute(recaptchaSiteKey, { action: type }).then(function (token) {
      document.querySelector('[name="g-recaptcha-response"]').setAttribute('value', token);
    });
  });
};
